import axios from "axios";
import store from "@/store";
import Cookies from "js-cookie";

const isDev = process.env.NODE_ENV === "development";
const baseURL = isDev
  ? process.env.VUE_APP_API_BASE_PATH
  : process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_BASE_PATH;

const apiClient = axios.create({
  baseURL,
  withCredentials: false,
  header: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    const {
      response: { status },
    } = error;
    if (status === 401) {
      if (Cookies("auth_token")) {
        store.dispatch("logout");
      }
    }
    throw error;
  }
);

const apiClientBlob = axios.create({
  baseURL,
  withCredentials: false,
  header: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  responseType: "blob",
});

apiClientBlob.interceptors.response.use(
  response => response,
  error => {
    const {
      response: { status },
    } = error;
    if (status === 401) {
      if (Cookies("auth_token")) {
        store.dispatch("logout");
      }
    }
    throw error;
  }
);
/*
// Cancel Token Request Interceptor
apiClient.interceptors.request.use(
  function(config) {
    //  Generate cancel token source
    let source = axios.CancelToken.source()
    // Set cancel token on this request
    config.cancelToken = source.token
    // Add to vuex to make cancellation available from anywhere
    store.commit("ADD_CANCEL_TOKEN", source)

    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

 */

export default apiClient;
export { apiClientBlob };
